import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Beranda from "@/pages/Beranda";
import Pemasukan from "@/pages/Pemasukan";
import Pengeluaran from "@/pages/Pengeluaran";
import KasbonPabrik from "@/pages/KasbonPabrik";
import KasbonPelanggan from "@/pages/KasbonPelanggan";
import UangKas from "@/pages/UangKas";
import Stok from "@/pages/Stok";
import RekapMingguan from "@/pages/RekapMingguan";
import LaporanBulanan from "@/pages/LaporanBulanan";
import Pengaturan from "@/pages/Pengaturan";

const Splash = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
    <Loader2 className="w-8 h-8 animate-spin text-[var(--jt-emerald-2)]" />
  </div>
);

function Protected() {
  const { user, ws } = useAuth();
  if (user === null || (user && !ws)) return <Splash />;
  if (!user) return <Navigate to="/masuk" replace />;
  return <Layout />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/masuk" element={<LoginRoute />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Beranda />} />
            <Route path="/pemasukan" element={<Pemasukan />} />
            <Route path="/pengeluaran" element={<Pengeluaran />} />
            <Route path="/kasbon-pabrik" element={<KasbonPabrik />} />
            <Route path="/kasbon-pelanggan" element={<KasbonPelanggan />} />
            <Route path="/uang-kas" element={<UangKas />} />
            <Route path="/stok" element={<Stok />} />
            <Route path="/rekap-mingguan" element={<RekapMingguan />} />
            <Route path="/laporan-bulanan" element={<LaporanBulanan />} />
            <Route path="/pengaturan" element={<Pengaturan />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
